import service from '@/middleware'

const scoringApi = {
    /**
     * Datos para la tabla del reporte de infracciones descartadas
     */
    async getDiscardedInfractionsReport (driverCodes, thingIds, from, to) {
        const body = {
            driverCodes,
            thingIds,
            from,
            to
        }
        const response = await service.http.post(
            `/api/scoring/discarded-infractions-report`, body)
        return response
    },

}

export default scoringApi
